import { useQuery } from '@pinia/colada';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import showingsService from '../services/showings.service';
import { showingsQueryKey } from './showings.query';

export function useShowingQuery() {
  const route = useRoute();
  const showingId = computed(() => route.params.showingId as string);

  return useQuery({
    key: () => [showingsQueryKey, showingId.value],
    query: () => showingsService.get(showingId.value),
  });
}
